<div style="background: #000; padding: 6px 16px; display: flex; align-items: center;">
  <img src="assets/img/blacklight/BLACKLIGHT.COM_Black_Logo_Icon.png" style="width:75px;height:40px;margin-right: 16px;" alt="Logo">
  <span style="color: #26a9e8; font-size: 36px; font-family: 'Segoe UI', Arial, sans-serif; font-weight: 300;">S3 Password Reset</span>
</div>
<router-outlet></router-outlet>